import TContext from "src/engine/context/TContext";
import IUIItem from "src/engine/interface/IUIItem";

export interface IPageMgrContext {
    loading: IUIItem[];
    renderPage: (item: { props: any; ename: string; key: number }, index: number, isShow: boolean) => any;
}

const PageMgrContext = new TContext<IPageMgrContext>({
    loading: [],
    renderPage: (item: { props: any; ename: string; key: number }) => {
        return null;
    }
});

export default PageMgrContext;
